// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__aGiVK","checked":"checkbox_checked__WVfzN"};